const color = {
    THEME: '#39D1B3',
    THEME_HEAVY: '#40BE9A',
    FORM : {
        BORDER: {
            NORMAL: '#ADBEB9',
            ERROR: '#D80027'
        },
        BG:{
            NORMAL: '#F6F8F7',
            ERROR: '#FEF2F3'
        }
    },

    ROOT: {
        NAV_BORDER: '#E9E9E9',
        BG: '#F5F5F5'
    },

    GLOBAL: {
        BORDER: '#E0DFE1',
        CANCEL_BORDER: '#C7C7C8',
        LINK: '#349DFF'
    }
}

export default color;